var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"inspire"}},[_c('AppBar'),_c('div',{staticClass:"zalo-page"},[_c('vh-zalo-inbox',{attrs:{"api-base":_vm.apiBase,"socket-base":_vm.socketBase,"token":_vm.token}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }